import { render, staticRenderFns } from "./NotificationsPage.vue?vue&type=template&id=58556044&scoped=true&"
import script from "./NotificationsPage.vue?vue&type=script&lang=ts&"
export * from "./NotificationsPage.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsPage.vue?vue&type=style&index=0&id=58556044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58556044",
  null
  
)

export default component.exports